import { css, keyframes } from "styled-components";

export const spin = keyframes`
  0% {
    transform: rotate(0deg);
    opacity: .2;
  }
  50%{
    opacity: 1;
    rotate(180deg);
  }
  100% {
    transform: rotate(359deg);
    opacity: .2;
    
  }
`;

export const spinAnimation = () => css`${spin} 3s linear infinite;`;
